define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var urlUtil = require('util/url.util');
    var dateUtil = require('util/date.util');
    var StepView = require('portlets/registration/registration.step.view');
    var StepModel = require('portlets/registration/generic/registration.step.model');

    module.exports = StepView.extend({

        events: function() {
            return _.extend({
                'change [name=countrycode]': 'validatePersonalId',
                'change [name=citizenship]': 'validatePersonalId',
                'input .fn-escape-symbols': 'handleFieldWithEscapeChange'
            }, StepView.prototype.events(), this.additionalEvents);
        },

        /**
         * @override
         */
        initialize: function() {
            var config, options;

            StepView.prototype.initialize.apply(this, arguments);

            config = this.options.model.get('config');
            options = _.extend({
                genericFields: this.options.config.genericFields
            }, config);

            this.stepModel = new StepModel(options);
        },

        handleFieldWithEscapeChange: function(e) {
            e.preventDefault();

            e.target.value = e.target.value.replace(this.config.genericEscapedSymbols[e.target.name], '');
        },

        render: function() {
            this.config = this.parseConfigForRender(this.config);

            return StepView.prototype.render.apply(this, arguments);
        },

        parseConfigForRender: function(config) {
            var genericFields = config.genericFields;

            config.genericFieldsForRender = genericFields

                // group buttons by the same line
                .reduce(function(memo, field) {
                    if (!field.active) {
                        return memo;
                    }

                    if (field.type !== 'button') {
                        memo.push(field);
                        return memo;
                    }

                    var lastButtonsCluster = _.last(memo);
                    var lastButtonInCluster = _.last(lastButtonsCluster);

                    if (lastButtonInCluster && lastButtonInCluster.onSameLine && field.onSameLine) {
                        lastButtonsCluster.push(field);
                    } else {
                        memo.push([field]);
                    }

                    return memo;
                }, [])

                // group button from the same line by alignment
                .reduce(function(memo, buttonsCluster) {
                    if (!Array.isArray(buttonsCluster)) {
                        memo.push(buttonsCluster);
                        return memo;
                    }

                    var index = 0;
                    var cluster = buttonsCluster.reduce(function(clusterMemo, button) {
                        if (index < 2) {
                            if (button.align === 'center') {
                                index = 1;
                            } else if (button.align === 'right') {
                                index = 2;
                            }
                        }

                        clusterMemo[index].push(button);

                        return clusterMemo;
                    }, [[], [], []]);

                    memo.push(cluster);

                    return memo;
                }, [])
                .map((field) => {
                    if (field.type === 'text' && field.urlQueryParameter) {
                        field.urlValue = urlUtil.getLocationParameterByName(field.urlQueryParameter) || '';
                    }

                    if (field.type === 'datePicker') {
                        const defaultMax = 'today';
                        const defaultMin = '-100y';
                        const dateRangeRule = field.validationRules.find(item => item.type === 'dateRange');
                        const max = field.validation && dateRangeRule?.max || defaultMax;
                        const min = field.validation && dateRangeRule?.min || defaultMin;
                        const maxYear = new Date(dateUtil.parseStringDateToUnixFormat(max))?.getFullYear() || new Date(dateUtil.parseStringDateToUnixFormat(defaultMax))?.getFullYear();
                        const minYear = new Date(dateUtil.parseStringDateToUnixFormat(min))?.getFullYear() || new Date(dateUtil.parseStringDateToUnixFormat(defaultMin))?.getFullYear();
                        const yearsRange = _.range(maxYear, minYear - 1);

                        config.yearsRange = {
                            ...config.yearsRange,
                            [field.name]: yearsRange
                        };
                    }

                    field.isLabelAsteriskEnabled = field.validationRules?.some((rule) => rule.type === 'required' && rule.isLabelAsteriskEnabled);
                    field.isPlaceholderAsteriskEnabled = field.validationRules?.some((rule) => rule.type === 'required' && rule.isPlaceholderAsteriskEnabled);

                    return field;
                });

            return config;
        },

        validatePersonalId: function() {
            var personalIdField = this.form.$el.find('[name=personalId]')[0];
            personalIdField && this.form.validateField(personalIdField.closest('.fn-validate'), this.form.data());
        },

        /**
         * @override
         */
        className: function() {
            return StepView.prototype.className
                + ' portlet-registration__step--' + this.model.get('config').genericColumnCount;
        },

        /**
         * @override
         */
        getValidationData: function() {
            return this.stepModel.getValidationData(this.data);
        },

        getPlayerTags: function() {
            return this.stepModel.getPlayerTags(this.data);
        }
    });
});
